import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const axios = require("axios");
const Config = require("./config");

export const SubscribeEmail = async (body, toggle) => {
  let baseUrl = CheckToggleUrl(toggle);

  let suffixUrl = "/waitlist/email";

  return axios.default.post(baseUrl + suffixUrl, body).then((res) => {
    return res.data;
  });
};

const EventApi = createApi({
  reducerPath: "EventApi",

  baseQuery: fetchBaseQuery({
    baseUrl: "http://localhost:4000",
  }),

  endpoints(builder) {
    return {
      CreateEvent: builder.mutation({
        query: (payload) => {
          return {
            url: "/createEvent",
            method: "POST",
            body: payload,
          };
        },
      }),
      Connect: builder.mutation({
        query: (payload) => {
          return {
            url: "/connect",
            method: "POST",
            body: {
              publicKey: payload.publicKey,
              actualMessage: payload.actualMessage,
              signMessage: payload.signMessage,
            },
          };
        },
      }),
    };
  },
});

export const { useCreateEventQuery, useConnectMutation } = EventApi;
export { EventApi };

const CheckToggleUrl = (toggle) => {
  if (toggle) {
    return Config.default.Url.BaseProduction;
  } else {
    return Config.default.Url.BaseLocal;
  }
};
